module.exports = __webpack_public_path__ + "static/img/logo.9d117df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/logo.png
// module id = F5cW
// module chunks = 2